import { fetchData } from '../utils/netUtils';

const { affiliates } = window.__TBX_ENV__;

class AffiliatesService {
  apiURL: string;
  projectID: string;
  authKey: string;

  /**
   * constructor to Affiliates service instance
   */
  constructor() {
    this.apiURL = affiliates.baseURL;
    this.projectID = affiliates.projectID;
    this.authKey = affiliates.authKey;
  }

  getActivateProductURL(tbxUserToken: string, cp: string) {
    const URL = `${this.apiURL}/partnergw/affiliates/${this.projectID}/subscription/activate?toolbox_user_token=${tbxUserToken}&cp=${cp}`;
    return URL;
  }

  getBindingInitializationURL() {
    const URL = `${this.apiURL}/processes/${this.projectID}/binding/initiate`;
    return URL;
  }

  getInvertedBindingInitializationURL(projectId:string, cp:string, affiliateIdp:string, returnUrl:string, failureUrl:string) {
    const URL = `${this.apiURL}/processes/${projectId}/${cp}/inverted-binding/initiate?affiliate_idp=${affiliateIdp}&return_url=${returnUrl}&failure_url=${failureUrl}`;
    return URL;
  }

  getProjectConfiguration(tbxUserToken: string) {
    const URL = `${this.apiURL}/partnergw/affiliates/subscriptions?toolbox_user_token=${tbxUserToken}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': this.authKey,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  postReactivateProduct(cp: string, body: {}) {
    const URL = `${this.apiURL}/processes/${this.projectID}/${cp}/subscriptions/binding`;
    const options = {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }

  getDevices(customerId: string, cp: string){
    const URL = `${this.apiURL}/devices/${this.projectID}/${cp}/${customerId}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  deleteDevice({deviceToken, customerId, return_url, cp} : {deviceToken: string, customerId: string, return_url: string, cp: string}){
    const URL = `${this.apiURL}/devices/${this.projectID}/${cp}/_deviceManager/${customerId}?${new URLSearchParams({
      devices: deviceToken,
      return_url,
    }).toString()}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

}

export default AffiliatesService;
